module.exports = __webpack_public_path__ + "img/smalllogo1.fcbb663d.png";